// @flow
import type { Vehicle } from '../types';
import { CALL_API } from '../middlewares/api';
import * as constants from '../constants/vehicleConstants';

type LoadVehiclesAction = {|
    type: typeof constants.LOAD,
    data: $ReadOnlyArray<Vehicle>
|};

type SetVehicleAction = {|
    type: typeof constants.SET,
    data: Vehicle
|};

type UnsetVehicleAction = {|
    type: typeof constants.UNSET,
    data: string
|};

type CreateVehicleAction = {|
    type: typeof constants.CREATE,
    [CALL_API]: {
        method: 'POST',
        endpoint: '/api/car',
        data: $ReadOnly<{
            icao: string,
            callsign: string
        }>
    }
|};

export type VehicleAction =
    | LoadVehiclesAction
    | SetVehicleAction
    | UnsetVehicleAction
    | CreateVehicleAction;


export default {
    loadVehicles: (vehicles: $ReadOnlyArray<Vehicle>): LoadVehiclesAction => ({
        type: constants.LOAD,
        data: vehicles
    }),
    setVehicle: (vehicle: Vehicle): SetVehicleAction => ({
        type: constants.SET,
        data: vehicle
    }),
    unsetVehicle: (icao: string): UnsetVehicleAction => ({
        type: constants.UNSET,
        data: icao
    }),
    createVehicle: (vehicle: Vehicle): CreateVehicleAction => ({
        type: constants.CREATE,
        [CALL_API]: {
            method: 'POST',
            endpoint: '/api/car',
            data: vehicle
        }
    })
};